module.exports = __webpack_public_path__ + "SamsungOne-800.e82cff1ac6baa207b7f1.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-800.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-800.ttf
// module chunks = styles